import { render, staticRenderFns } from "./CoordinatorDashboard.vue?vue&type=template&id=1b7648d4&scoped=true&"
import script from "./CoordinatorDashboard.vue?vue&type=script&lang=js&"
export * from "./CoordinatorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorDashboard.vue?vue&type=style&index=0&id=1b7648d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7648d4",
  null
  
)

export default component.exports